export const KIND_WORDS: Record<string, string> = {
  money: "Price",
  "selling window date": "Selling dates",
  "stock and buying rule": "Stock rule",
  "pack count": "Pack count",
  "parcel measure": "Parcel size",
  "customs or delivery rule": "Delivery rule",
  "product measure": "Product size",
  "descriptive attribute": "Description",
  "identity thing": "Identity",
  "selling text": "Selling text",
  classification: "Category",
  "target audience": "Audience",
  "legal requirement": "Legal",
  file: "File",
  "seller setting": "Seller setting",
  "unit only": "Unit",
  "one store only": "One store only",
  "system field": "System field",
};

export const kindWord = (kind: string) => KIND_WORDS[kind] ?? kind;

export const leafLabel = (key: string) =>
  key.replace(/_/g, " ").replace(/\b\w/g, (letter) => letter.toUpperCase());
